import { render } from "./TabCartHistory.vue?vue&type=template&id=6a432ab9&scoped=true"
import script from "./TabCartHistory.vue?vue&type=script&lang=js"
export * from "./TabCartHistory.vue?vue&type=script&lang=js"

import "./TabCartHistory.vue?vue&type=style&index=0&id=6a432ab9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a432ab9"]])

export default __exports__